export const STAFF_VIEW_LIST = ' STAFF_VIEW_LIST';
export const STAFF_EDIT = ' STAFF_EDIT';
export const STAFF_CREATE = ' STAFF_CREATE';

export const PROFILE_MANAGER_FINANCES_EDIT = 'PROFILE_MANAGER_FINANCES_EDIT';
export const PROFILE_STOCKMAN_FINANCES_EDIT = 'PROFILE_STOCKMAN_FINANCES_EDIT';
